import { listOrgCertificates } from "./certHelpers"
import { listPendingCredentialRequests } from "./credentialRequestHelpers"
import { listOrgVerificationEvents } from "./verificationEventHelpers"
import { buildBuckets, dateKeyFor } from "./dateRangeHelpers"

export const computeCredentialOverview = async (orgId, rangeKey = "30d") => {
  const [{ certificates }, { requests }, { events }] = await Promise.all([
    listOrgCertificates(orgId),
    listPendingCredentialRequests(orgId),
    listOrgVerificationEvents(orgId),
  ])

  const issued = certificates?.length || 0
  const revoked = certificates?.filter((c) => c?.status === "revoked")?.length || 0
  const verified = certificates?.filter((c) => c?.status !== "revoked")?.length || 0
  const pending = requests?.length || 0

  const buckets = buildBuckets(rangeKey)
  const issuedOverTime = buckets?.map((bucket) => {
    const count = certificates?.filter((c) => {
      const issued = c?.issueDate ? dateKeyFor(new Date(c.issueDate)) : null
      return rangeKey === "12m" ? issued?.startsWith(bucket?.key) : issued === bucket?.key
    })?.length
    return { key: bucket?.key, label: bucket?.label, count }
  })

  const verificationOverTime = buckets?.map((bucket) => {
    const count = events?.filter((e) => {
      const ms = e?.createdAt?.toMillis ? e.createdAt.toMillis() : null
      if (ms === null) return false
      const d = new Date(ms)
      const key = dateKeyFor(d)
      return rangeKey === "12m" ? key?.startsWith(bucket?.key) : key === bucket?.key
    })?.length
    return { key: bucket?.key, label: bucket?.label, count }
  })

  return {
    issued,
    verified,
    pending,
    revoked,
    issuedOverTime,
    verificationOverTime,
    hasVerificationActivity: (events?.length || 0) > 0,
  }
}